import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../login.service';
import { Logo } from 'app/logo.env';

@Component({
  selector: 'app-auth-contracts',
  templateUrl: './auth-contracts.component.html',
  styleUrls: ['../app-contracts/app-contracts.component.scss']
})

export class AuthContractsComponent implements OnInit {
  public img: any = `assets/images/loader.gif`;
  public valor: any;
  public contracts = [];

  constructor(
    public dialogRef: MatDialogRef<AuthContractsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    const currCodeCobra = this.loginService.getCurrentCodeCobra()

    this.data.forEach(element => {
      if (currCodeCobra != element.codeCobra) {
        element.imageSrc = Logo(element.office.logoImagem);
        element.fantasia = element.office.name;
        this.contracts.push(element);
      }
    });
  }

  keyUserCompany(id) {
    this.valor = id;
  }

  selectContract(contract?: any) {


    if (typeof contract == 'undefined') {
      this.loginService._token(this.valor, this.dialogRef, this.data, true);
    } else {
      this.loginService._token(contract, this.dialogRef, this.data, true);
    }
  }
}
